module.exports = global["Backshift"] = require("-!./backshift.onms.js");